module.exports = __webpack_public_path__ + "static/img/边框2.91457c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框2.svg
// module id = FeLS
// module chunks = 2